﻿import { } from '../../../Content/view.hbs.js'
import { App, Router } from './app.js'
import { } from './actions.js'
import { } from './handlebars.js'
import { } from './events.js'
import route from '../constants/route.js'
import * as Helper from '../helper.js'

window.App = App
window.Helper = Helper

App.Store.sync(route)
App.Store.fetch('store', 'current', { include: '*' })
	.then(m =>
	{
		App.Config.sync(
		{
			customerId: m.relationships.customer.data.id,
			languageId: m.relationships.language.data.id,
			storeId: m.id
		})

		let language = App.Store.model(m.relationships.language.data.type, App.Config.languageId)

		if (m?.attributes)
		{
			document.title = m.attributes.title
			document.querySelector('head meta[name="description"]')?.setAttribute('content', m.attributes.description)
			document.querySelector('head meta[name="keywords"]')?.setAttribute('content', m.attributes.keywords)

			if (language?.attributes?.locale)
				document.documentElement.setAttribute('lang', language.attributes.locale)

			if (m.attributes.pecom)
				document.body.classList.add('pecom')
		}

		// #region Localization
		fetchI18n(language.attributes.seoCode, language.attributes.version)
		// #endregion Localization

		// #region App Ready
		App.Ready = true

		// Init Modal Components
		Object.keys(App.Component).forEach(c =>
		{
			if (c.indexOf('modal') == 0) App.Component[c]()
		})

		const eventAppReady = new CustomEvent('app.ready', { bubbles: true, cancelable: true, detail: {} })
		document.dispatchEvent(eventAppReady)

		document.addEventListener('action.after', App.Component.HandleErrors)
		// #endregion App Ready

		return m
	})
	.then(store =>
	{
		if (!Helper.hasRole('Administrator'))
		{
			// Store closed redirect
			const storeClosed = store?.attributes?.closed == true
			if (storeClosed && location.pathname != '/storeclosed' && location.pathname != '/login')
				Router.navigate('/storeclosed')
		}
	})
	.catch(function()
	{
		App.ReadyI18n = true
		App.Ready = true
		App.Router.navigate('/store/notfound')
	})

function fetchI18n(i18nSeoCode, i18nVersion)
{
	let url = '/Content/i18n/' + i18nSeoCode + '.json?v=' + i18nVersion
	return fetch(url)
		.then(response => response.json())
		.then(json => App.Store.sync(json, url))
		.catch(error => console.error(error))
		.finally(() =>
		{
			App.ReadyI18n = true
			const eventI18nReady = new CustomEvent('i18n.ready', { bubbles: true, detail: {} })
			document.dispatchEvent(eventI18nReady)
		})
}

export * from './app.js'
